import {CountUp} from "countup.js";

(function(){
    document.addEventListener("DOMContentLoaded", function (event) {
        var elements = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName('cc-hero-number_value--animate');
        var i;
        var counterElements: any[] = [];
        for (i = 0; i < elements.length; i++) {
            var options = {
                startVal: parseInt(elements[i].getAttribute('data-start-value')),
                decimalPlaces: 0,
                separator: '.',
                decimal: ',',
                duration: 3
            };
            counterElements[i] = new CountUp(elements[i], parseInt(elements[i].getAttribute('data-value')), options);
            elements[i].parentElement.style.visibility = 'visible';
            window.setTimeout(
                function () {
                    for (var i = 0; i < elements.length; i++) {
                        counterElements[i].start();
                    }
                }, 1000
            )
        }
    });
}());

